<template>
  <div>
    <transition name="slide-fade" appear>
      <div class="container">
        <b-row>
          <b-col><h2>Perfil del Docente</h2></b-col>
        </b-row>
        <b-row v-if="!editarFoto && !editarDatos">
            <b-col cols="lg-3">
              <b-card class="text-center">
                <b-col cols="lg-12">
                  <b-img :src="$store.state.fotoUsuario" width="150px"/>
                </b-col>
                <b-col cols="lg-12" class="mt-3">
                  <b-button variant="outline-primary" class="px-4" @click="editarFoto=!editarFoto">Cambiar Foto</b-button>
                </b-col>
              </b-card>
            </b-col>
            <b-col cols="lg-9">
              <b-card>
                <div class="container">
                  <b-row>
                    <b-col cols="md-12" class="mt-3">
                      <b-label>Nombres y Apellidos:</b-label>
                      <h5>{{this.$store.state.nombresUsuario}} {{this.$store.state.apellidosUsuario}}</h5>
                    </b-col>
                    <b-col cols="md-12" class="mt-3">
                      <b-label>{{this.$store.state.tipoDocumentoUsuario}}:</b-label>
                      <h5>No.: {{this.$store.state.documentoUsuario}}</h5>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>
        </b-row>
        <b-row v-if="!editarFoto">
        </b-row>
        <b-row v-else>
          <b-col>
            <b-card>
              <b-row><b-col cols="lg-12"><h4>Cambiar Foto del Docente</h4></b-col></b-row>
              <b-row class="mt-3">
                <b-col cols="lg-4">
                  <croppa v-model="croppa"
                    show-remove-button="true"
                    width="200"
                    height="200"
                    placeholder="Seleccionar Imagen: Click aquí"
                    placeholder-color="#000"
                    placeholder-font-size="12"
                    canvas-color="transparent"
                    remove-button-color="black"
                    remove-button-size=""
                    show-loading="true"
                    loading-size="50"
                    loading-color="#606060"
                    quality="1"
                    accept=".jpg, .jpeg"
                    file-size-limit="1536000"
                    @file-type-mismatch="onFileTypeMismatch"
                    @file-size-exceed="onFileSizeExceed"
                    prevent-white-space="true">
                  </croppa>
                  <b-button class="px-5" variant="primary" @click="dataUrl = croppa.generateDataUrl('image/jpg', 0.8)">Recortar Imagen</b-button>
                </b-col>
                <b-col cols="lg-4">
                  
                  <br>
                  <div class="size">Output size: {{dataUrl.length}}</div>
                  <img :src="dataUrl">
                  <textarea name="base64" id="base64" v-model="dataUrl"></textarea>
                  <br>
                  <input type="file" id="file" ref="file">
                  <br>
                  <button @click="download('image/jpg', 0.8)">download 20% compressed JPEG</button>
                  <br><hr><br>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
  import axios from "axios"

  export default {
    name: 'Dashboard',
    components: {
    },
    data () {
      return {
        editarFoto: false,
        editarDatos: false,
        croppa: {},
        dataUrl: '',
        fechaActualizacion: ''
      }
    },
    methods: {
      cargaDatosUsuario() {
        this.fechaActualizacion = new Date(this.$store.state.fechaActualizacionFichaUsuario)
        this.fechaActualizacion = this.fechaActualizacion.toLocaleDateString() + ' a las ' + this.fechaActualizacion.toLocaleTimeString()
      },
      onFileTypeMismatch (file) {
        this.mensajeEmergente('danger','Tipo de Archivo Invalido','Por favor seleccione un archivo de tipo JPG')
      },
      onFileSizeExceed (file) {
        this.mensajeEmergente('danger','Archivo Demasiado Grande','Por favor seleccione un archivo con un máximo de 1.5 Mb')
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      },
      download(type, compressionRate) {
        this.croppa.generateBlob(blob => {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.download = Date.now() + '_' + this.$store.state.documentoUsuario;
          a.href = url;
          console.log(url)
          a.click();
          URL.revokeObjectURL(url);
        }, type, compressionRate);
      }
    },
    beforeMount() {
      this.cargaDatosUsuario()
    }
  }
</script>

